import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Logo from '../../assets/svgs/Logo';
import LoginShape from '../../assets/images/login.png';

const LoginHeader = ({ className }) => {
    return (
        <div className={className}>
            <Logo className="LoginHeader__Logo" />
            <img src={LoginShape} alt="loginheader" />
        </div>
    );
};

LoginHeader.propTypes = {
    className: PropTypes.string.isRequired
};

export default styled(LoginHeader)`
    > svg {
        display: block;
        margin: 0 auto;
    }

    img {
        display: block;
        max-width: 100%;
        height: auto;
        margin-right: auto;
        margin-left: auto;
    }

    > *:last-of-type {
        margin-top: 1.5em;
    }
`;
